import dayjs from 'dayjs';
import { isString } from '@scripts/utils/type-utils';

export const isAfterToday = (date: string): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(date) > today;
};

export const isBeforeToday = (date: string): boolean => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(date) < today;
};

// Eg. timezoneCode = 'America/LosAngeles'
export const getUtcOffset = ({
  timezoneCode,
  format = 'Z',
}: {
  timezoneCode: string;
  format: string;
}): string => {
  const now = dayjs().tz(timezoneCode);
  return now.format(format);
};

export const getLocaleDate = ({
  date,
  timezoneCode,
  formatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour12: false,
  },
}: {
  date: Date | string;
  timezoneCode: string;
  formatOptions: Intl.DateTimeFormatOptions;
}): string => {
  if (!date) {
    return '';
  }

  return new Intl.DateTimeFormat(
    'en-US',
    {
      ...formatOptions,
      timeZone: timezoneCode,
    },
  ).format(isString(date) ? new Date(date) : date);
};
